module.exports = __webpack_public_path__ + "img/shopping-cart-add.60b1d412.svg";